export const MS_IN_DAY = 24 * 60 * 60 * 1000;
export function getIsNewOffering(firstPublishedAt) {
  const millisSincePublished = Date.now() - firstPublishedAt;
  const daysSincePublished = millisSincePublished / MS_IN_DAY;
  return daysSincePublished < 30;
}